import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppContext } from "../../context/AppContext";
import {
  firstColumn,
  formatDataToTableColumnValues,
} from "../../utils/dataFormatter";
import {
  deleteData,
  postData,
  postInstituteAppData,
} from "../platform-components/api-integration-util";
import DynamicInput from "../platform-components/dynamic-input/dynamic-input";
import { Toaster } from "../platform-components/Toaster";
import { getUserDetails } from "../platform-components/utils/shared-data.service";
import Grid from "../platform-components/grid/Grid";

export default function Administration() {
  let [selectedTab, setSelectedTab] = useState("BRANCH");
  let [formState, setFormState] = useState(false);
  let [selectedItems, setSelectedItems]: any = useState([]);
  const {
    batches,
    branches,
    courses,
    subjects,
    tags,
    topics,
    users,
    roles,
    userSubjectMap,
    getSubjects,
    getCourses,
    getBranches,
    getBatches,
    getTopics,
    getTags,
    getUsers,
    getUserSubjectMap,
    getRoles,
  } = useContext(AppContext);
  let columns: any = [];
  let selectedRowData = [];

  if (selectedTab === "BRANCH") {
    const columnOrder = [
      "branchId",
      "branchName",
      "batches",
      "branchEmail",
      "branchState",
      "branchCountry",
      "branchAddress",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
      "active",
    ];
    columns = formatDataToTableColumnValues(branches, columnOrder);
    selectedRowData = branches;
  } else if (selectedTab === "SUBJECTS") {
    const columnOrder = [
      "subjectId",
      "subject",
      "topics",
      "yearTaught",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
    ];
    columns = formatDataToTableColumnValues(subjects, columnOrder);
    selectedRowData = subjects;
  } else if (selectedTab === "COURSES") {
    const columnOrder = [
      "courseId",
      "course",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
      "active",
    ];
    columns = formatDataToTableColumnValues(courses, columnOrder);
    selectedRowData = courses;
  } else if (selectedTab === "BATCH") {
    const columnOrder = [
      "batchId",
      "branchId",
      "batch",
      "startDate",
      "endDate",
      "subjects",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
    ];
    columns = formatDataToTableColumnValues(batches, columnOrder);
    selectedRowData = batches;
  } else if (selectedTab === "BATCH_DESCRIPTION") {
    /*
    const columnOrder = ["batchId"]
    columns = formatDataToTableColumnValues(batches, columnOrder)
    selectedRowData = batches
    */
  } else if (selectedTab === "TOPICS") {
    const columnOrder = [
      "topicId",
      "topic",
      "subjectId",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
    ];
    columns = formatDataToTableColumnValues(topics, columnOrder);
    selectedRowData = topics;
  } else if (selectedTab === "TAGS") {
    columns = formatDataToTableColumnValues(tags);
    selectedRowData = tags;
  } else if (selectedTab === "USERS") {
    /*
  else if (selectedTab === 'USER_SUBJECT_MAP') {
    const columnOrder = []
    columns = formatDataToTableColumnValues(userSubjectMap)
    selectedRowData = userSubjectMap
  }
  */
    const columnOrder = [];
    columns = formatDataToTableColumnValues(users, [
      "userId",
      "lastName",
      "firstName",
      "email",
      "password",
      "active",
      "userRoles",
      "roleId",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
    ]);
    selectedRowData = users;
  }
  if (selectedTab !== "BATCH_DESCRIPTION") {
    columns.unshift(firstColumn);
  }

  let [configData, updateConfigData] = useState({
    coursesList: [],
    branchesList: [],
    subjectsList: [],
    batchesList: [],
    topicList: [],
    tagList: [],
    usersList: [],
    rolesList: [],
    // userSubjectMapList: [], // Commented out
    confirm: [
      { key: "Yes", value: true },
      { key: "No", value: false },
    ],
  }) as any;

  useEffect(() => {
    updateConfigData((state: any) => {
      state["coursesList"] = courses;
      state["branchesList"] = branches;
      state["subjectsList"] = subjects;
      state["batchesList"] = batches;
      state["topicList"] = topics;
      state["tagList"] = tags;
      state["usersList"] = users;
      state["rolesList"] = roles;
      // state['userSubjectMapList'] = userSubjectMap; // Commented out
      return state;
    });
  }, [
    batches,
    branches,
    courses,
    /* userSubjectMap, */ subjects,
    tags,
    topics,
    updateConfigData,
    users,
    roles,
  ]);

  const reloadConfigData = () => {
    setSelectedItems([]);
    switch (selectedTab) {
      case "SUBJECTS":
        getSubjects();
        break;
      case "COURSES":
        getCourses();
        break;
      case "BRANCH":
        getBranches();
        break;
      case "BATCH":
        getBatches();
        break;
      case "TOPICS":
        getTopics();
        break;
      case "TAGS":
        getTags();
        break;
      /*
      case 'USER_SUBJECT_MAP':
        getUserSubjectMap()
        getSubjects();
        break;
      */
      case "BATCH_DESCRIPTION":
        getBatches();
        break;
      case "USERS":
        getUsers();
        getRoles();
        break;
    }
  };

  const outputEvent = (data: any, tabInfo: any) => {
    setFormState(false);
    if (tabInfo?.httpMethod === "DELETE") {
      if (selectedTab !== "SUBJECTS") {
        deleteData(
          `${tabInfo?.servicePath}${
            selectedTab === "USERS"
              ? "?userEmail=" + getUserDetails().email
              : ""
          }${
            selectedTab === "USER_SUBJECT_MAP"
              ? "?userId=" +
                selectedItems[0]?.userId +
                "&subjectId=" +
                selectedItems[0]?.subjectId
              : ""
          }`,
          {
            data: selectedItems,
          }
        )
          .then((res: any) => {
            Toaster(toast.TYPE.SUCCESS, `${tabInfo?.toasterMsg}`);
            reloadConfigData();
            setFormState(true);
          })
          .catch((e) => {
            Toaster(toast.TYPE.ERROR, "Error occured, Please try again");
          });
      } else {
        Toaster(
          toast.TYPE.ERROR,
          "deleting a subject is not allowed from the tool . Please contact admin"
        );
      }
    } else {
      if (tabInfo?.idColumn) {
        data[tabInfo?.idColumn] = 0;
      }
      if (tabInfo?.requiredFieldsforPayload) {
        Object.assign(data, tabInfo?.requiredFieldsforPayload);
      }
      data.active = selectedTab === "USERS" ? true : 1;
      if (selectedTab === "USERS") {
        data.userRoles = roles.filter((el) =>
          (data?.roleId || []).includes(String(el?.roleId))
        );
        data.roleId = 0;
        data.userId = getUserDetails().id;
        data.userRoles = (data?.userRoles || []).map((e) => {
          return {
            ...e,
            userId: getUserDetails()?.id,
            userRoleId: getUserDetails()?.roleId,
          };
        });
        data.tenantId = getUserDetails().tenantId;
      }
      if (selectedTab === "BATCH_DESCRIPTION") {
        postInstituteAppData(`${tabInfo?.servicePath}/${data.batchId}`, {
          data: data.batchDescription,
        })
          .then((res: any) => {
            Toaster(toast.TYPE.SUCCESS, `${tabInfo?.toasterMsg}`);
            reloadConfigData();
            setFormState(true);
          })
          .catch((e) => {
            Toaster(toast.TYPE.ERROR, "Error occured, Please try again");
          });
        return;
      }

      /*
      if (selectedTab === 'USER_SUBJECT_MAP') {
        data = {
          "subjectId": data.subjectId,
          "userIds": [
            data.userId
          ]
        }
      }
      */
      data.createdBy = getUserDetails().email;
      postData(
        `${tabInfo?.servicePath}${
          selectedTab === "USERS" ? "?userEmail=" + getUserDetails().email : ""
        }`,
        {
          data: data,
        }
      )
        .then((res: any) => {
          Toaster(toast.TYPE.SUCCESS, `${tabInfo?.toasterMsg}`);
          reloadConfigData();
          setFormState(true);
        })
        .catch((e) => {
          Toaster(toast.TYPE.ERROR, "Error occured, Please try again");
        });
    }
  };

  const gridOptions = {
    columnDefs: columns,
    rowData: selectedRowData,
    showGrid: true,
    rowSelection: "multiple",
    pagination: true,
    paginationPageSize: 20,
    onSelectionChanged: (params) => {
      setSelectedItems(
        params.api.getSelectedRows().map((e) => {
          switch (selectedTab) {
            case "SUBJECTS":
              return e.subjectId;
            case "COURSES":
              return e.courseId;
            case "BRANCH":
              return e.branchId;
            case "BATCH":
              return e.batchId;
            case "TOPICS":
              return e.topicId;
            case "TAGS":
              return e.tagId;
            /*
            case 'USER_SUBJECT_MAP':
              return {  userId: e.userId, subjectId: e.subjectId }
            */
            case "USERS":
              return e.userId;
          }
        })
      );
    },
  };

  return (
    <div>
      <ul className="nav">
        <li className="nav-item">
          <a
            className={`nav-link ${selectedTab === "BRANCH" ? "active" : ""}`}
            role="button"
            onClick={(e) => {
              setSelectedTab("BRANCH");
            }}
          >
            Branch
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${selectedTab === "BATCH" ? "active" : ""}`}
            role="button"
            onClick={(e) => {
              setSelectedTab("BATCH");
            }}
          >
            Batch
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${
              selectedTab === "BATCH_DESCRIPTION" ? "active" : ""
            }`}
            role="button"
            onClick={(e) => {
              setSelectedTab("BATCH_DESCRIPTION");
            }}
          >
            Batch Description
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${selectedTab === "COURSES" ? "active" : ""}`}
            role="button"
            onClick={(e) => {
              setSelectedTab("COURSES");
            }}
          >
            Course
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${selectedTab === "SUBJECTS" ? "active" : ""}`}
            role="button"
            onClick={(e) => {
              setSelectedTab("SUBJECTS");
            }}
          >
            Subject
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${selectedTab === "TOPICS" ? "active" : ""}`}
            role="button"
            onClick={(e) => {
              setSelectedTab("TOPICS");
            }}
          >
            Topics
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${selectedTab === "TAGS" ? "active" : ""}`}
            role="button"
            onClick={(e) => {
              setSelectedTab("TAGS");
            }}
          >
            Tags
          </a>
        </li>
        {/*
        <li className="nav-item">
          <a className={`nav-link ${selectedTab === 'USER_SUBJECT_MAP' ? 'active' : ''}`} role="button"
           onClick={(e) => {
            setSelectedTab('USER_SUBJECT_MAP');
          }}
          >
            Question Approver
          </a>
        </li>
        */}
        <li className="nav-item">
          <a
            className={`nav-link ${selectedTab === "USERS" ? "active" : ""}`}
            role="button"
            onClick={(e) => {
              setSelectedTab("USERS");
            }}
          >
            User Tab
          </a>
        </li>
      </ul>
      {selectedTab?.length > 0 && (
        <DynamicInput
          OutputEvent={outputEvent}
          tabName={selectedTab}
          config={configData}
          formReset={formState}
        />
      )}
      {gridOptions?.columnDefs.length > 0 && (
        <div style={{ height: "100%" }}>
          <Grid showGrid gridOptions={gridOptions} parent="dashboard" />
        </div>
      )}
    </div>
  );
}
